import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";
import { color } from "framer-motion";
import { toast } from "react-toastify";

const handleHover = (e, isHover) => {
  if (isHover) {
    e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
    e.currentTarget.style.background = "linear-gradient(90deg,#6366f1,#8b5cf6)";
    e.currentTarget.style.borderColor = "transparent";
    // Target the children manually or use a CSS class for better performance
    e.currentTarget.querySelector('h3').style.color = "#fff";
    e.currentTarget.querySelector('p').style.color = "rgba(255,255,255,0.8)";
  } else {
    e.currentTarget.style.transform = "translateY(0) scale(1)";
    e.currentTarget.style.background = "rgba(30, 41, 59, 0.5)";
    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
    e.currentTarget.querySelector('h3').style.color = "#38bdf8";
    e.currentTarget.querySelector('p').style.color = "#94a3b8";
  }
};

export default function PreviousYearPaper() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [questions, setQuestions] = useState([]);
  const [years, setYears] = useState([]);

  // 🔥 Fetch Questions
  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = () => {
    dispatch(
      httpRequest({
        key: API_END_POINTS.getAllPYQ.KEY,
        onSuccess: (res) => {
          const data = res.data || [];
          setQuestions(data);

          // 🔥 Extract unique years
          const uniqueYears = [
            ...new Set(
              data.map((q) => q.year?.toString()).filter(Boolean)
            ),
          ].sort((a, b) => b - a);

          setYears(uniqueYears);
        },
        onError: (err) => {
          console.log("Error fetching questions:", err);
          toast.error("Failed to load questions. Please try again later.");
        }
      })
    );
  };

  return (
    <div style={styles.container}>
  
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.title}>📚 Previous Year Papers</h2>
        <p style={styles.subtitle}>Select a year to start test</p>
      </div>

      {/* Cards */}
      <div style={styles.grid}>
        {years.length > 0 ? (
          years.map((year) => (
            <div
              key={year}
              style={styles.card}
              onClick={() => navigate(`/pyq/test/${year}`)}
              onMouseEnter={(e) => handleHover(e, true)}
              onMouseLeave={(e) => handleHover(e, false)}
            >
              <h3 style={styles.year}>{year}</h3>
              <p style={styles.text}>Start Test →</p>
            </div>
          ))
        ) : (
          <p>No data available</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px 20px",
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    background: "linear-gradient(135deg, #0f172a, #020617)",
    minHeight: "100vh",
  },


  header: {
    maxWidth: "1000px",
    margin: "0 auto 30px auto",
    textAlign: "center",
  },

  title: {
    fontSize: "30px",
    fontWeight: "800",
    color: "#e2e8f0",
    margin: 0,
  },

  subtitle: {
    color: "#899bb4",
    marginTop: "8px",
    fontSize: "15px",
  },

  grid: {
    maxWidth: "1000px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "20px",
  },

  card: {
    background: "linear-gradient(135deg, #0f172a, #020617)",
    borderRadius: "18px",
    padding: "30px 20px",
    textAlign: "center",
    cursor: "pointer",
    border: "1px solid #e2e8f0",
    boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
  },

  year: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#38bdf8",
    marginBottom: "8px",
  },

  text: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: "500",
  },
};